import React from 'react'
import "./Spinner.css"

function CustomSpinner({ size }) {
    return (
        <div className='customeSpinnerFrame' style={{ fontSize: `${size * 5}px` }}>
            <div className="growth-spinner">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>
        </div>
    )
}

export default CustomSpinner